import { AxiosRequestConfig } from "axios";

import { IBriefResource } from "../../briefs";
import { IClassroomResource } from "../../classrooms";
import { IProfessionalSituationResource } from "../../professional-situations";
import { createApiQueryHook, IOrderable, IPaginateable, mapOrder, mapPagination } from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IEducationalBriefList } from "../types/IEducationalBriefList";

export interface IEducationalBriefListQueryParameters extends IPaginateable, IOrderable<"rank"> {
    filters?: {
        briefs?: RelationalFilter<IBriefResource>;
        professionalSituations?: RelationalFilter<IProfessionalSituationResource>;
        classrooms?: RelationalFilter<IClassroomResource>;
    };
}

export type IEducationalBriefListQueryResult = IEducationalBriefList;

const mapFilters = (filters: IEducationalBriefListQueryParameters["filters"]) => {
    const { briefs, professionalSituations, classrooms } = filters ?? {};
    return {
        "brief.uuid": mapRelationalFilter(briefs),
        "professionalSituation.uuid": mapRelationalFilter(professionalSituations),
        "classroom.uuid": mapRelationalFilter(classrooms),
    };
};

export const educationalBriefListQuery = ({
    pagination,
    filters,
    order,
}: IEducationalBriefListQueryParameters): AxiosRequestConfig => {
    return {
        method: "GET",
        url: `/educational_briefs${serialize(
            {
                ...mapFilters(filters),
                ...mapPagination(pagination),
                ...mapOrder(order),
            },
            true,
        )}`,
    };
};

export const useEducationalBriefListQuery = createApiQueryHook<
    IEducationalBriefListQueryParameters,
    IEducationalBriefListQueryResult
>(educationalBriefListQuery);
